import { initializeApp } from "firebase/app"
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut, createUserWithEmailAndPassword } from "firebase/auth"
// import { connectAuthEmulator } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyDmVCNde-xno6IlvMrrnyjRqHDgL5n_Z-Q",
  authDomain: "ariapura-6fa3f.firebaseapp.com",
  projectId: "ariapura-6fa3f",
  storageBucket: "ariapura-6fa3f.appspot.com",
  messagingSenderId: "667437898783",
  appId: "1:667437898783:web:fb0a1c63b2b4addfe4892a",
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)

/*
if (location.hostname === "localhost:8080") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099")
}
*/

export { app, auth, db, signInWithEmailAndPassword, onAuthStateChanged, signOut, createUserWithEmailAndPassword }